const GroupActionTypes = {
  START_FETCH_GROUP_ITEMS: 'START_FETCH_GROUP_ITEMS',
  FETCH_GROUP_ITEMS_SUCCESS: 'FETCH_GROUP_ITEMS_SUCCESS',
  FETCH_GROUP_ITEMS_FAILURE: 'FETCH_GROUP_ITEMS_FAILURE',
  START_FETCH_GROUPS: 'START_FETCH_GROUPS',
  FETCH_GROUPS_SUCCESS: 'FETCH_GROUPS_SUCCESS',
  FETCH_GROUPS_FAILURE: 'FETCH_GROUPS_FAILURE',

  ADD_GROUP_ITEM: 'ADD_GROUP_ITEM',
  ADD_GROUP_ITEM_SUCCESS: 'ADD_GROUP_ITEM_SUCCESS',
  ADD_GROUP_ITEM_FAILURE: 'ADD_GROUP_ITEM_FAILURE',

  UPDATE_GROUP: 'UPDATE_GROUP',
  UPDATE_GROUP_SUCCESS: 'UPDATE_GROUP_SUCCESS',
  UPDATE_GROUP_FAILURE: 'UPDATE_GROUP_FAILURE',

  UPDATE_GROUP_ITEM: 'UPDATE_GROUP_ITEM',
  UPDATE_GROUP_ITEM_SUCCESS: 'UPDATE_GROUP_ITEM_SUCCESS',
  UPDATE_GROUP_ITEM_FAILURE: 'UPDATE_GROUP_ITEM_FAILURE',

  ADD_GROUP: 'ADD_GROUP',
  ADD_GROUP_SUCCESS: 'ADD_GROUP_SUCCESS',
  ADD_GROUP_FAILURE: 'ADD_GROUP_FAILURE',

  DELETE_GROUP_ITEM: 'DELETE_GROUP_ITEM',
  DELETE_GROUP_ITEM_SUCCESS: 'DELETE_GROUP_ITEM_SUCCESS',
  DELETE_GROUP_ITEM_FAILURE: 'DELETE_GROUP_ITEM_FAILURE',

  DELETE_GROUP: 'DELETE_GROUP',
  DELETE_GROUP_SUCCESS: 'DELETE_GROUP_SUCCESS',
  DELETE_GROUP_FAILURE: 'DELETE_GROUP_FAILURE',
};

export default GroupActionTypes;
